import React, { useState } from "react";

const accounts = [
  { id: 5, name: "المصاريف", type: "Expense", parent_id: null },
  { id: 20, name: "التكاليف المباشرة", type: "Expense", parent_id: 5 },
  { id: 21, name: "أجور الفنيين والميكانيكيين", type: "Expense", parent_id: 20 },
  { id: 22, name: "مواد استهلاكية", type: "Expense", parent_id: 20 },
  { id: 23, name: "المصروفات التشغيلية", type: "Expense", parent_id: 5 },
  { id: 24, name: "الإيجار الشهري للورشة", type: "Expense", parent_id: 23 },
  { id: 25, name: "الحملات الإعلانية والتسويق", type: "Expense", parent_id: 23 },
  { id: 26, name: "مصاريف مكتبية", type: "Expense", parent_id: 23 },
  { id: 27, name: "استهلاك الأصول الثابتة", type: "Expense", parent_id: 23 },
  { id: 6, name: "الإيرادات", type: "Revenue", parent_id: null },
  { id: 14, name: "إيرادات خدمات الصيانة وقطع الغيار", type: "Revenue", parent_id: 6 },
  { id: 9, name: "الأصول", type: "Asset", parent_id: null },
  { id: 10, name: "الأصول المتداولة", type: "Asset", parent_id: 9 },
  { id: 12, name: "البنك", type: "Asset", parent_id: 10 },
  { id: 13, name: "الخزينة", type: "Asset", parent_id: 10 },
  { id: 17, name: "العملاء", type: "Asset", parent_id: 10 },
  { id: 18, name: "المخزون", type: "Asset", parent_id: 10 },
  { id: 11, name: "الأصول الثابتة", type: "Asset", parent_id: 9 },
  { id: 16, name: "الأثاث والمفروشات", type: "Asset", parent_id: 11 },
  { id: 7, name: "حقوق الملكية", type: "Equity", parent_id: null },
  { id: 19, name: "رأس المال", type: "Equity", parent_id: 7 },
  { id: 8, name: "الخصوم", type: "Liability", parent_id: null },
];

// Convert flat list to tree
function buildTree(list) {
  const map = {};
  const roots = [];

  list.forEach(item => {
    map[item.id] = { ...item, children: [] };
  });

  list.forEach(item => {
    if (item.parent_id) {
      map[item.parent_id].children.push(map[item.id]);
    } else {
      roots.push(map[item.id]);
    }
  });

  return roots;
}

const accountTree = buildTree(accounts);

// Recursive TreeNode with level-based indentation
const levelColors = ["#2196F3", "#4CAF50", "#FF9800", "#9C27B0"]; 
// Level 0 = blue, Level 1 = green, Level 2 = orange, Level 3+ = purple

const TreeNode = ({ node, level = 0 }) => {
  const [open, setOpen] = useState(true);
  const indent = 20;

  const color = levelColors[level] || levelColors[levelColors.length - 1]; // if deeper, use last color

  return (
    <li>
      <div
        style={{
          cursor: node.children.length > 0 ? "pointer" : "default",
          paddingRight: level * indent,
          margin: "2px 0",
          display: "inline-block",
        }}
        onClick={() => setOpen(!open)}
      >
        {node.children.length > 0 && (
          <span style={{ color: "#555", marginRight: 5 }}>
            {open ? "▼" : "▶"}
          </span>
        )}
        <span
          style={{
            backgroundColor: color + "33", // light transparent background
            color: color,
            padding: "2px 8px",
            borderRadius: 5,
            fontWeight: "bold",
            transition: "0.2s",
          }}
        >
          {node.name}
        </span>
      </div>
      {node.children.length > 0 && open && (
        <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
          {node.children.map(child => (
            <TreeNode key={child.id} node={child} level={level + 1} />
          ))}
        </ul>
      )}
    </li>
  );
};

// Main App
export default function App() {
  return (
    <div style={{ fontFamily: "Arial, sans-serif", padding: '20px',paddingTop:'2px' }}>
      <h2>شجرة الحسابات</h2>
      <ul style={{ listStyle: "none", padding: 0 }}>
        {accountTree.map(node => (
          <TreeNode key={node.id} node={node} />
        ))}
      </ul>
    </div>
  );
}
